import { useToastContext } from '../context/ToastContext';
import { ToastType } from '../components/Toast';

export const useToast = () => {
  const { showToast } = useToastContext();

  return {
    showToast: (message: string, type?: ToastType) => {
      showToast(message, type);
    },
    showSuccess: (message: string) => {
      showToast(message, 'success');
    },
    showError: (message: string) => {
      showToast(message, 'error');
    },
    showWarning: (message: string) => {
      showToast(message, 'warning');
    },
    showInfo: (message: string) => {
      showToast(message, 'info');
    },
  };
};

























